import axios from 'axios';
import { DIVISIONS_ENDPOINT } from '../api/api';

export const FETCH_DIVISIONS_SUCCESS = 'FETCH_DIVISIONS_SUCCESS';

export const startFetchDivisions = () => {
  return async (dispatch) => {
    try {
      const divisions = await axios({
        method: 'get',
        url: `${DIVISIONS_ENDPOINT}`,
        headers: JSON.parse(sessionStorage.user)
      });
      dispatch(fetchDivisionsSuccess(divisions.data));
    } catch (error) {
      console.log(error.message);
    }
  };
};

const fetchDivisionsSuccess = (divisions) => ({
  type: FETCH_DIVISIONS_SUCCESS,
  divisions
});



// WEBPACK FOOTER //
// ./src/actions/divisionActions.js